module.exports = __webpack_public_path__ + "img/font-awesome-alt.ed8d19b9.svg";